import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
  FormControl,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";

const LocationsEditor = ({
  locations = [],
  onChange,
  defaultType = "",
}) => {
  const [localLocations, setLocalLocations] = useState(locations);

  useEffect(() => {
    setLocalLocations(locations);
  }, [locations]);

  const handleChange = (index, field, value) => {
    const updated = [...localLocations];
    updated[index][field] = value;
    setLocalLocations(updated);
    onChange(updated);
  };

  const handleNestedChange = (index, parentField, childField, value) => {
    const updated = [...localLocations];
    updated[index][parentField][childField] = value;
    setLocalLocations(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newLocation = {
      id: crypto.randomUUID(),
      type: defaultType,
      agencyCode: "",
      agencyCodeSetCode: "",
      code: "",
      countryCode: "",
      subentityCode: "",
      supraentityCode: "",
      description: "",
      allocationPercentage: {
        value: 0,
        unitCode: ""
      },
      ruleCode: ""
    };
    const updated = [...localLocations, newLocation];
    setLocalLocations(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localLocations];
    updated.splice(index, 1);
    setLocalLocations(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size="md">Locations</Heading>
        <IconButton icon={<HiOutlinePlus />} size="md" onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>Type</Th>
            <Th>Agency Code</Th>
            <Th>Agency Code Set</Th>
            <Th>Code</Th>
            <Th>Country</Th>
            <Th>Allocation %</Th>
            <Th>Rule Code</Th>
            <Th>Description</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localLocations.map((loc, idx) => (
            <Tr key={loc.id}>
              <Td>
                <CodesetSelect
                  codesetCode="3227"
                  value={loc.type ? { code: loc.type, description: "" } : null}
                  onChange={(val) => handleChange(idx, "type", val.code)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="3055"
                  value={loc.agencyCode ? { code: loc.agencyCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "agencyCode", val.code)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="C01"
                  filter="#RegulatoryProvision"
                  value={loc.agencyCodeSetCode ? { code: loc.agencyCodeSetCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "agencyCodeSetCode", val.code)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode={loc.agencyCodeSetCode}
                  value={loc.code ? { code: loc.code, description: "" } : null}
                  onChange={(val) => handleChange(idx, "code", val.code)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={loc.countryCode}
                  onChange={(e) => handleChange(idx, "countryCode", e.target.value)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  type="number"
                  value={loc.allocationPercentage?.value ?? ""}
                  onChange={(e) =>
                    handleNestedChange(idx, "allocationPercentage", "value", parseFloat(e.target.value) || 0)
                  }
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={loc.ruleCode}
                  onChange={(e) => handleChange(idx, "ruleCode", e.target.value)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  value={loc.description}
                  onChange={(e) => handleChange(idx, "description", e.target.value)}
                  size="sm"
                  height="32px"
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size="md"
                  onClick={() => handleDelete(idx)}
                  aria-label="Delete location"
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default LocationsEditor;
